import axios, { AxiosError } from "axios";
import axiosRetry from "axios-retry";
// import { addError } from "src/store/errorBoundarySlice";
import store from "../store/store";
import authService from "src/services/authService";
// import { login } from "src/store/userSlice";
// import authService from "src/services/authService";

const TOKEN_EXPIRED_MESSAGE =
  "The security token included in the request is expired";

const apiClient = axios.create({
  baseURL: "https://gamma.na.safety-genie-api.whs.amazon.dev",
});

axiosRetry(apiClient, {
  retries: 1,
  retryDelay: (retryCount) => {
    console.log(`retry attempt: ${retryCount}`);
    return retryCount * 2000;
  },
  retryCondition: (error: AxiosError) => {
    console.log("retryCondition err: ", JSON.stringify(error));
    const status = error.response?.status;
    const message: string = error.response?.data?.message ?? "";
    // for any errors related to auth, backend will return 403 with different message
    // if the security token/credential has expired (after one hour), then simplest way is to re-login to refresh
    // the credentials
    if (status === 403 && message.includes(TOKEN_EXPIRED_MESSAGE)) {
      authService.login();
      return false;
    }
    // for any other types of 403, typically for authenticated but unauthorized Amazon users, no need to retry
    // for everything else, retry for now till further observation
    return !!status && status !== 403;
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status !== 429) {
      if (error.response?.data?.message) {
        // store.dispatch(addError(error.response?.data?.message));
      } else {
        // store.dispatch(addError(error?.message));
      }
    }
  }
);

export default apiClient;
